module.exports = __webpack_public_path__ + "media/images/logos/google-bc713cec30d61a2001b300ed28147e82.svg";